import { Injectable } from '@angular/core';
import { BookModel, BookTextField } from '@core/models/bible/book-model';
import { ApiService } from '@core/service/api/api.service';
import { UnsubscribeOnDestroyAdapter } from '@shared';
import { ApiUrl } from '@shared/tools/constants/api.endpoints';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BookService extends UnsubscribeOnDestroyAdapter
{
  endpoint: string = ApiUrl.BookV1;
  public textField=BookTextField;
  public loadingDataList=false;
  public bookDataList: BookModel[]  = [];

  constructor( private apiService: ApiService) {super();}

  getAll(data?: any) : Observable<any>{
    return this.apiService.getData(`${this.endpoint}/lsg`, data );
  }

  getOne( id: string ) : Observable<any> {
    return this.apiService.getData(`${this.endpoint}/${id}` );
  }

  async loadAllData()  {
    if(this.bookDataList?.length<=0){
      this.loadingDataList=true;
      this.subs.sink = await this.getAll().subscribe({
        next: (result) => {
          this.bookDataList = result;
          // let albumGroupeVIDE = new AlbumGroupeModel();
          // this.albumGroupeDataList.unshift(albumGroupeVIDE);
          // this.loadingAlbumGroupeDataList=false;
          //console.log(`this.groupeDataList:`, this.groupeDataList);
        },
        error: (ex) => {
          console.log(ex);
          this.loadingDataList=false;
        },
        complete: () => {
          this.loadingDataList=false;
        }
      });
    }
  }

}
